import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { Button } from '@coursera/cds-core';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { SearchBar } from 'bundles/discussions/components/forumsV2-Search';
import TrackedButton from 'bundles/page/components/TrackedButton';
import TrackedTextInput from 'bundles/page/components/TrackedTextInput';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/SearchBox';

type Props = {
  animateToSearch: () => void;
  animateFromSearch: () => void;
  nextElementId?: string;
  previousElementId?: string;
  onSubmit?: (q: string) => void;
};

type State = {
  showBar: boolean;
  query: string;
};

class SearchBox extends React.Component<Props, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof SearchBox.contextTypes>;

  state = {
    showBar: true,
    query: '',
  };

  handleQueryChange = (newQuery: string) => {
    this.setState({
      query: newQuery,
    });
  };

  handleFocus = () => {
    const { animateToSearch } = this.props;
    animateToSearch();
  };

  handleBlur = () => {
    const { animateFromSearch } = this.props;
    animateFromSearch();
  };

  handleClear = () => {
    this.setState({
      query: '',
    });
  };

  handleTab = (e: React.KeyboardEvent<HTMLElement>) => {
    const { nextElementId } = this.props;
    const element = nextElementId && document && document.getElementById(nextElementId);
    if (element) {
      e.preventDefault();
      element.focus();
    }
  };

  handleShiftTab = (e: React.KeyboardEvent<HTMLElement>) => {
    const { previousElementId } = this.props;
    const element = previousElementId && document && document.getElementById(previousElementId);
    if (element) {
      e.preventDefault();
      element.focus();
    }
  };

  submitSearch = () => {
    const { query } = this.state;
    const { router } = this.context;
    const { onSubmit } = this.props;

    const {
      location: { pathname },
    } = router;
    if (query) {
      const q = query.replace('*', '');

      if (onSubmit !== undefined) {
        onSubmit(q);
      }

      router.push({
        pathname,
        params: {},
        query: { q },
      });
    }
  };

  render() {
    const { showBar, query } = this.state;
    if (showBar) {
      return (
        <SearchBar
          query={query}
          handleSubmit={this.submitSearch}
          handleChange={this.handleQueryChange}
          handleBlur={this.handleBlur}
          handleShiftTab={this.handleShiftTab}
          handleTab={this.handleTab}
          handleClear={this.handleClear}
          focus
        />
      );
    } else {
      return (
        <div className="rc-ForumsV2__SearchBox expand-block flex-1">
          <div className="large-screen search-bar">
            <div className="input-area">
              <TrackedTextInput
                trackingName="search_box"
                onClick={this.handleFocus}
                // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                onFocus={this.handleFocus}
                value={query}
                className="rc-ForumsV2__search-box search-input"
                aria-label={_t('Search')}
              />
            </div>
            <Button
              component={TrackedButton}
              type="button"
              onClick={this.handleFocus}
              variant="primary"
              withVisibilityTracking={true}
              requireFullyVisible={false}
              trackingName="search_forum"
            >
              {_t('Search')}
            </Button>
          </div>
          <div className="mobile hide horizontal-box align-items-right">
            <Button
              component={TrackedButton}
              type="button"
              onClick={this.handleFocus}
              variant="primary"
              withVisibilityTracking={true}
              requireFullyVisible={false}
              trackingName="search_forum"
            >
              {_t('Search')}
            </Button>
          </div>
        </div>
      );
    }
  }
}

export default SearchBox;
